export function joinNomeCognome(nome: string|undefined, cognome: string|undefined): string {
    if (!nome && !cognome) {
        return ''
    }
    if (!nome) {
        return cognome || ""
    }
    if (!cognome) {
        return nome || ""
    }
    return `${cognome}, ${nome}`
}

export function ellipsisText(text: string, maxLength: number) {
  if (!text || text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + '...';
}